import { DocumentService } from './../documents/document.service';
import { ActionParameterDefinitionDTO } from './../api/plyca-dtos-v2';
import { ActionService } from './action.service';
import {
  Component,
  AfterContentInit,
  ElementRef,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { ActionDTO, ActionExecutionDTO, ActionExecutionRequestDTO, ActionExecutionState, ActionParameterDTO, I18nData, TaskDTO } from '../api/plyca-dtos';
import { ServiceLocator } from '../ServiceLocator';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { generateRandomIdentifier, UIService } from '../ui.service';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { FieldConfig, InterfaceSettings } from '../api/contract-notice-dto';
import { catchError, concatMap, filter, finalize, switchMap, take, tap } from 'rxjs/operators';
import { Observable, interval, of, throwError } from 'rxjs';
import { ActionResultDTO } from '../api/plyca-dtos-v2';
import { TranslateService } from '@ngx-translate/core';
import { PlycaDataService } from '../../services/plyca.service';
import { CacheService } from '../../services/cache.service';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as lodash from 'lodash';
import { Configuration } from '../conf/app.constants';
import { DATEPIPE_DATETIME_FORMAT } from '../../services/language.service';
import { ConfirmationService } from 'primeng-lts/api';
import { PropertyService } from '../properties/property.service';


@Component({
  selector: 'actions-process',
  templateUrl: 'actions.process.template.html',
  providers: [DialogService, UIService],
})
export class ActionsProcessComponent
  extends BaseComponent
  implements AfterContentInit, OnInit, OnDestroy {


  private helpTag = HelpType.ACTIONS;

  public DATEPIPE_DATETIME_FORMAT = DATEPIPE_DATETIME_FORMAT;

  public action: ActionDTO;
  public task: TaskDTO;
  public paramsDef: ActionParameterDefinitionDTO[];
  public actionService: ActionService;
  public multipleTargetList: Array<string>;

  public windowHash: string;
  public windowHashMessage: string;
  public loading = true;
  result: any;
  // dto: any;
  public model = {};

  private uiService: UIService;
  running: boolean;
  private translate: TranslateService;
  // configuration: any;

  private cacheService: CacheService;
  // private preparedAction: ActionDTO;
  private localConfig: InterfaceSettings;
  private localConfigLoaded: boolean;

  showingActionExecutionWayPoints = false;
  selectedActionExecution: ActionExecutionDTO;

  public showWarningMessage = false;
  public warningMessage: string;
  public warningResult: any;

  public runAction = false;


  // running = false;
  showFinalResult = false;
  totalSeleccionados = 0;
  totalProcesados = 0;
  totalErrores = 0;
  actionExecutionResult: ActionExecutionRequestDTO;

  constructor(
    public ref: DynamicDialogRef,
    private route: ActivatedRoute,
    private router: Router,
    public dialogConfig: DynamicDialogConfig,
    public waitService: WaitLoadingService,
    private elem: ElementRef,
    private headerActionsService: HeaderActionsService,
    public plycaService: PlycaDataService,
    public dialogService: DialogService,
    private plycaErrorHandler: PlycaErrorHandler,
    public helpService: HelpService,
    private documentService: DocumentService,
    private _http: HttpClient,
    private confirmationService: ConfirmationService,
    protected configuration: Configuration,
    public propertyService: PropertyService,
  ) {
    super();
    this.windowHash = generateRandomIdentifier();
    this.windowHashMessage = generateRandomIdentifier();
    this.localConfigLoaded = false;
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.ACTIONS));
    this.uiService = ServiceLocator.injector.get(UIService);
    // this.actionService = ServiceLocator.injector.get(ActionService);

    this.translate = ServiceLocator.injector.get(TranslateService);

    this.cacheService = ServiceLocator.injector.get(CacheService);

    this.action = dialogConfig['action'];

    let helpTags = [];
    helpTags.push(this.helpTag);

    if (dialogConfig['helpTag']) { // Machacamos el valor
      helpTags = [dialogConfig['helpTag']];
    }
    if (this.action?.identifier) { // Concatebamos
      helpTags.push(this.action.identifier);
    }
    this.subscribe(this.helpService.showContextHelpObservable(helpTags));


    // this.dto = dialogConfig['obj'];
    this.action.target = dialogConfig['dto'];
    this.runAction = dialogConfig['runAction'];
    this.paramsDef = dialogConfig['paramsDef'];
    this.multipleTargetList = dialogConfig['multipleTargetList'];

    if (!this.paramsDef || this.paramsDef === undefined
      && this.action.definition && this.action.definition.parametersDefinition) {
      this.paramsDef = this.action.definition.parametersDefinition;
    }
    // invocamos al prepare siempre. Si la accion no necesita preparacion no tendra efecto.
    // Es necesario para establecer un target en la ejecucion masiva
    // if ((this.action.needsPreparation && ((this.action.target && this.action.target.identifier)) || this.multipleTargetList)) {
    this.prepareAction();
    // }
    this.model['action'] = this.action;
  }

  getTarget() {
    let _target;
    if (this.action.target) {
      _target = this.action.target ? this.action.target.identifier : null;
    } else if (this.multipleTargetList) {
      // si es una accion con ejecucion multiple, la preparamos con el primero de los elementos. ¿Sirve esto siempre?
      // SI NO SIRVE Y LA ACCION NECESITA PREPARACION NO PODRÍA EJECUTARSE EN MODO MULTIPLE
      _target = this.multipleTargetList[0];
    }
    // si no tengo valor para target, consulto directamente el formElement del formulario
    if (!_target) {
      let paramTarget = this.getParameter('TARGET');
      if (paramTarget) {
        _target = paramTarget.value;
      }
    }
    return _target;
  }

  public prepareAction() {
    this.waitService.startWaiting();
    // para invocar al preparation
    let params: any = {};
    let _target = this.getTarget();
    if (_target) {
      params.TARGET = _target;
      if (this.action.parameters !== undefined) {
        let targetParam = this.action.parameters.find(param => param.name === 'TARGET');
        // TRATAMIENTO ESPECIAL DEL PARAMETRO TARGET. SI TENEMOS VALOR DIRECTAMENTE SE OCULTA
        if (targetParam && _target) {
          // para evitar que salga en el formulario un campo con el target si ya esta establecido
          targetParam.visible = false;
          targetParam.value = _target;
        }
      }

      let url = '/userAPI/v1/actions/' + this.action['definition'].identifier;
      this.subscribe(
        this.plycaService
          .get(url, '/preparation', params)
          .pipe(
            finalize(() => {
              this.waitService.cancelWaiting();
            })
          ),
        (act: any) => {
          if (act) {
            this.action = act;
            this.model['action'] = this.action;

            if (act.definition.paramsUpdated && act.definition.parametersDefinition) {
              this.paramsDef = act.definition.parametersDefinition;
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  ngOnDestroy() {
    this.uiService = null;
    this.dialogConfig = null;
    this.dialogService = null;
    this.headerActionsService.clearWindowActions(this.windowHash);


    super.ngOnDestroy();
  }

  ngOnInit() {
    this.windowHash = generateRandomIdentifier();
    this.waitService.startWaiting();
    this.initHeaderActions();
    this.loading = false;
    this.waitService.cancelWaiting();
  }

  ngAfterContentInit() { }

  isLoaded() {
    return !this.loading;
  }
  initHeaderInfo() { }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.download',
        'fa fa-download',
        'btn-primary',
        () => {
          return this.isRunning();
        },
        this.windowHash
      ),
      () => {
        this.downloadLogResult();
      });

    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      () => {
        this.close();
      });
  }

  isRunning() {
    return this.running;
  }

  close(ret = undefined) {
    this.ref.close(ret);
  }

  isButtonMode(): boolean {
    if (this.action.parameters) {
      let result = this.action.parameters.filter(
        (param) => param.formFieldType === 'BUTTON'
          && param.possibleValues && param.possibleValues.length > 0
      );

      return result.length === 1 ? true : false;
    }
    return false;
  }

  public _execute(parameter?: ActionParameterDTO, valueParameter?: any): Observable<any> {

    if (parameter && valueParameter && this.action && this.action.parameters) {
      this.action.parameters.forEach(element => {
        /*if (element && element.name === 'taskId' && this.task && this.task.identifier) {
          element.value = this.task.identifier;
        } */

        if (element && element.name === parameter.name) {
          element.value = valueParameter;
        }
      });
    }

    if (!this.checkParameters(this.action)) {
      let actionCheckMessage: string = this.translate.instant('Actions.exec.' + this.action.identifier + '.mandatoryParam');
      // si no lo hemos logrado traducir lo reseteamos
      if (actionCheckMessage
        && actionCheckMessage.startsWith('Actions.exec.')) {
        actionCheckMessage = null;
      }
      this.uiService.showMessage(
        actionCheckMessage ? actionCheckMessage : new I18nData('Actions.exec.mandatoryParam'),
        new I18nData('General.info')
      );
      this.running = false;
      return;
    }
    this.waitService.startWaiting();

    let parameters = this.parameters2string(this.action);
    console.log(
      'Ejecutando acción',
      this.action.identifier,
      'con los siguiente parametros',
      parameters
    );

    if (this.action.identifier === 'CLEAR_CACHE_PROPERTIES') {
      this.subscribe(this.cacheService.renew());
    }
    if (this.runAction) {
      if (this.multipleTargetList) {
        this.runMultiTargetAction(parameters);
      } else {
        this.subscribe(
          this.plycaService.runActionUsingPUT(this.action, parameters).pipe(
            finalize(() => {
              this.running = false;
              this.waitService.cancelWaiting();
            })
          ),
          (result: ActionResultDTO) => {
            this.processResult(result);
          },
          (err) => {
            this.plycaErrorHandler.showServerError(err);
          }
        );
      }
    } else {
      this.subscribe(
        this.plycaService.runActionLink(this.action, parameters).pipe(
          finalize(() => {
            this.running = false;
            this.waitService.cancelWaiting();
          })
        ),
        (result: ActionResultDTO) => {
          this.processResult(result);
        },
        (err) => {
          this.plycaErrorHandler.showServerError(err);
        }
      );
    }
  }

  public execute(parameter?: ActionParameterDTO, valueParameter?: any): Observable<any> {
    if (this?.action?.definition?.warningMessage) {
      this.confirmationService.confirm({
        message: this.action.definition.warningMessage,
        accept: () => {
          return this._execute(parameter, valueParameter);
        },
        reject: () => {
          console.log('No se confirma la ejecución de la acción.')
          return of(undefined)
        }
      });
    } else {
      return this._execute(parameter, valueParameter);
    }


  }

  getStatusIcon(action: any) {
    switch (action?.state) {
      case ActionExecutionState.SUCCESS:
        return 'fas fa-check text-success  fa-lg';
      case ActionExecutionState.ERROR:
        return 'fas fa-exclamation-circle text-danger fa-lg';
      case ActionExecutionState.RUNNING:
        return 'fa fa-spinner loading-spin fa-lg';
    }
  }

  /*public executeOLD(parameter?: ActionParameterDTO, valueParameter?: any): Observable<any> {

    if (parameter && valueParameter && this.action && this.action.parameters) {
      this.action.parameters.forEach(element => {
        if (element && element.name === parameter.name) {
          element.value = valueParameter;
        }
      });
    }

    if (!this.checkParameters(this.action)) {
      let actionCheckMessage: string = this.translate.instant('Actions.exec.' + this.action.identifier + '.mandatoryParam');
      // si no lo hemos logrado traducir lo reseteamos
      if (actionCheckMessage
        && actionCheckMessage.startsWith('Actions.exec.')) {
        actionCheckMessage = null;
      }
      this.uiService.showMessage(
        actionCheckMessage ? actionCheckMessage : new I18nData('Actions.exec.mandatoryParam'),
        new I18nData('General.info')
      );
      this.running = false;
      return;
    }
    this.waitService.startWaiting();

    let parameters = this.parameters2string(this.action);
    console.log(
      'Ejecutando acción',
      this.action.identifier,
      'con los siguiente parametros',
      parameters
    );

    if (this.action.identifier === 'CLEAR_CACHE_PROPERTIES') {
      this.subscribe(this.cacheService.renew());
    }
    this.subscribe(
      this.plycaService.runActionLink(this.action, parameters).pipe(
        finalize(() => {
          this.running = false;
          this.waitService.cancelWaiting();
        })
      ),
      (result: ActionResultDTO) => {
        console.log('Acción ejecutada: ', result);
        if (result.identifier === 'OK') {
          if (result.file) {
            if (result?.file?.showFileOnDownload) {
              this.documentService.viewFile(result.file);
            } else {


              this.subscribe(
                this.plycaService.downloadTmpIvan(result.file),
                () => {
                  this.uiService.showSuccess(
                    this.translate.instant('Actions.exec.ok'),
                    this.translate.instant('General.info'),
                    'success'
                  );
                  this.close();
                  console.log('Fichero embedded descargado con exito');
                },
                (err) => {
                  let message =
                    this.translate.instant('Actions.exec.error') + ': ' + err;
                  this.uiService.showMessage(message, 'Error', 'errorStyle');
                }
              );
            }
          } else if (result.redirect && result.redirect.contractFolderId) {
            this.openDossier(result.redirect.contractFolderId);
            this.close();
          } else if (result.objectResult) {
            if (result.showSuccessMessage) {
              let msgObj = result.objectResult
                ? '\n' + JSON.stringify(result.objectResult)
                : '';
              this.uiService.showMessage(msgObj, 'Info', 'errorStyle');
            }
            if (result.returnObjectResult) {
              this.close(result.objectResult);
            }
          } else {
            this.uiService.showSuccess(
              this.translate.instant('Actions.exec.ok'),
              this.translate.instant('General.info'),
              'success'
            );
            // this.uiService.showMessage('La acción se ha ejecutado correctamente', 'Ok', 'successStyle');
            if (!result.repeatable) {
              this.close();
            }
          }
        } else {
          let message = this.translate.instant('General.errorMessage');
          if (result.showWarningMessage && result.description) {
            //variable a true
            this.showWarningMessage = true;
            this.warningMessage = result.description;
            this.warningResult = result.objectResult;
          } else {
            if (result.description) {
              message = result.description;
            }
            this.uiService.showContent(message, 'Error', 'errorStyle');
          }
        }
      },
      (err) => {
        this.plycaErrorHandler.showServerError(err);
      }
    );
  }*/

  processResult(result: ActionResultDTO) {
    console.log('Acción ejecutada: ', result);
    if (result.identifier === 'OK') {
      if (result.file) {
        if (result?.file?.showFileOnDownload) {
          this.documentService.viewFile(result.file);
        } else {


          this.subscribe(
            this.plycaService.downloadTmpIvan(result.file),
            () => {
              this.uiService.showSuccess(
                this.translate.instant('Actions.exec.ok'),
                this.translate.instant('General.info'),
                'success'
              );
              this.close();
              console.log('Fichero embedded descargado con exito');
            },
            (err) => {
              let message =
                this.translate.instant('Actions.exec.error') + ': ' + err;
              this.uiService.showMessage(message, 'Error', 'errorStyle');
            }
          );
        }
      } else if (result.redirect && result.redirect.contractFolderId) {
        this.openDossier(result.redirect.contractFolderId);
        this.close();
      } else if (result.objectResult) {
        if (result.showSuccessMessage) {
          let msgObj = result.objectResult
            ? '\n' + JSON.stringify(result.objectResult)
            : '';
          this.uiService.showMessage(msgObj, 'Info', 'errorStyle');
        }
        if (result.returnObjectResult) {
          this.close(result.objectResult);
        }
      } else {
        this.uiService.showSuccess(
          this.translate.instant('Actions.exec.ok'),
          this.translate.instant('General.info'),
          'success'
        );
        // this.uiService.showMessage('La acción se ha ejecutado correctamente', 'Ok', 'successStyle');
        if (!result.repeatable) {
          this.close();
        }
      }
    } else {
      let message = this.translate.instant('General.errorMessage');
      if (result != null && result.request != null && result.request.state === 'NOT_ALLOWED' && result.request.description != null && result.request.description != '') {
        message = result.request.description;
      }
      if (result.showWarningMessage && result.description) {
        // variable a true
        this.showWarningMessage = true;
        this.warningMessage = result.description;
        this.warningResult = result.objectResult;
        this.headerActionsService.clearWindowActions(this.windowHashMessage);

        this.subscribe(this.headerActionsService
          .addWindowAction(
            'General.accept',
            'fas fa-check',
            'btn-primary',
            true,
            this.windowHashMessage
          ), () => {
            this.acceptWarningMessage();
          });
        this.subscribe(this.headerActionsService
          .addWindowAction(
            'General.cancel',
            'fas fa-times',
            'btn-secondary',
            true,
            this.windowHashMessage
          ), () => {
            this.closeWarningMessage();
          });
        /*this.uiService.showConfirmMessage({
          message: result.description,
          header: 'Aviso',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.close(result.objectResult);
            console.log('SE ACEPTA');
          },
          reject: () => {
            console.log('NO SE ACEPTA');
          }
        });*/
      } else {
        if (result.description) {
          message = result.description;
        }
        this.uiService.showContent(message, 'Error', 'errorStyle');
      }
    }
  }

  openDossier(contractFolderId: string) {
    this.router.navigate(['/dossierInfo/' + contractFolderId], { queryParams: { component: 'CONTRACTS', } });
    /*if (this.dossierType && this.dossierType === 'CONTRACTS') {
      this.router.navigate(['/dossierInfo/' + this.project.identifier],
      { queryParams: { component: 'CONTRACTS', divisionId: getSimpleIdentifierFromString(this.division.identifier) } });
    } else {
      this.router.navigate(['/dossierInfo/' + this.project.identifier]);
    }*/
  }

  private parameters2string(action: ActionDTO): string {
    let parametersAsString = '';
    // let targetSet = false;
    if (action.parameters) {
      parametersAsString = action.parameters
        .filter((param) => param.value && param.name !== 'TARGET')
        .map((param) => {
          if (param.value && param.value[0] && param.value[0].identifier) {
            return `${encodeURIComponent(param.name)}=${encodeURIComponent(param.value[0].identifier)}`;
          } else if (param.value instanceof Array) {
            let valTemp = '';
            param.value.forEach(v => {
              valTemp += v + ',';
            });
            valTemp = valTemp.substring(0, valTemp.length - 1);
            return `${encodeURIComponent(param.name)}=${encodeURIComponent(valTemp)}`;
          } else {
            if (param.value.identifier) {
              return `${encodeURIComponent(param.name)}=${encodeURIComponent(param.value.identifier)}`;
            } else {
              return `${encodeURIComponent(param.name)}=${encodeURIComponent(param.value)}`;
            }
          }
        })
        .join('&');
    }

    // establecer target
    if (parametersAsString !== '') {
      parametersAsString += '&';
    }
    if (this.multipleTargetList) {
      parametersAsString += this.multipleTargetList.map((target) => `TARGET=${target}`).join('&');
    } else {
      let _target = this.getTarget();
      if (_target) {
        parametersAsString += 'TARGET=' + _target;
      }
    }
    return parametersAsString;
  }

  private getParameter(name: string): ActionParameterDTO {
    if (this.action.parameters) {
      let result = this.action.parameters.find((param) => param.name === name);
      return result;
    }
    return null;
  }

  // Comprueba si los parametros obligatorios tiene valor
  private checkParameters(action: ActionDTO): boolean {
    if (action.parameters) {
      let mandatoryParams = action.parameters.filter((param) => param.required);
      if (mandatoryParams.length > 0) {
        mandatoryParams = mandatoryParams.filter((param) => param.value == null);
      }
      // let ret = this.action.parametersDefinition
      //   .filter(param => param.required)
      // no tengo parametros obligatorios, o si los hay tienen valor
      return mandatoryParams.length === 0 ? true : false;
    }
    // si no hay params true
    return true;
  }
  private setLocalConfig(config: FieldConfig) {

    if (!lodash.isEmpty(this.localConfig)) {
      let localFieldConfig: FieldConfig;
      localFieldConfig = this.localConfig.fieldGroups[0].fieldList.find((field) => field.id === config.id);

      lodash.merge(config, localFieldConfig);
    }
  }

  // Metodo para resolver problema de parametros con . en el nombre
  private patchJsonPath(path: string): string {
    return path ? path.replace(/\./g, '_') : undefined;
  }

  createFieldConfig(parameter: ActionParameterDTO): FieldConfig {
    let config = new FieldConfig();
    config.type = parameter.formFieldType ? parameter.formFieldType : 'TEXT';
    if (config.type === 'NUMERIC') {
      config.type = 'INTEGER';
    }
    if (config.type === 'BOOLEAN') {
      config.type = 'YES_NO';
    }

    if ((parameter.name === 'taskId' || parameter.name === 'TARGET') && !parameter.visible) {
      config.condClearFormControl = 'true'; // No queremos que el formElement lo limpie si no es visible por si viene ya informado.
    }

    if (config.type === 'DROPDOWN' || config.type === 'BUTTON') {
      config.data = [];
      if (parameter.possibleValues) {
        parameter.possibleValues.forEach((val) =>
          config.data.push({ label: val.description, value: val.identifier })
        );
      }
      config.orderByDescription = false;
    }
    this.model[this.patchJsonPath(parameter.name)] = parameter;
    config.tooltipText = parameter.description;
    config.jsonField = parameter.jsonPath ? this.patchJsonPath(parameter.jsonPath) : (this.patchJsonPath(parameter.name) + '.value');
    config.id = parameter.name;
    config.description = parameter.description;
    config.required = '' + parameter.required;
    config.visibility = parameter.visible !== undefined ? '' + parameter.visible : 'true';
    config.maxlength = parameter.maxLength;
    config.minlength = parameter.minLength;

    config.editable = parameter.editable;

    if (this.paramsDef && this.paramsDef.length > 0) {
      // Datos de la definición FORMFILED
      let definition = this.paramsDef.find(
        (fieldDef) => fieldDef.identifier === parameter.name
      );
      if (definition) {
        config.idBuscador = definition.idSearch ? definition.idSearch : '';

        if (definition.parameters) {
          config.parameters = definition.parameters;
        }

        config.autoSearch = true;
        if (definition.autoSearch !== undefined) {
          config.autoSearch = definition.autoSearch;
        }

        if (config.type === 'SEARCH' && definition.idSearch === 'UOSEARCH') {
          config.type = 'UOSEARCH';
          if (!this.localConfigLoaded) {
            this.subscribe(this
              ._http
              .get<InterfaceSettings>('assets/json/accion/' + this.action.identifier + '.json')
              .pipe(
                tap((localConfig) => {
                  this.localConfigLoaded = true;
                  console.log(localConfig);
                  this.localConfig = localConfig;
                  this.setLocalConfig(config);
                }
                ),
                catchError((error: any) => {
                  if (error.status === 404) {
                    this.localConfigLoaded = true;
                    return of(new InterfaceSettings());
                  } else {
                    throwError(error);
                  }
                })
              )
            );
          } else {
            this.setLocalConfig(config);
          }
        }

        if (config.type === 'SEARCH' && definition.idSearch === 'DIVISIONSEARCH') {
          config.type = 'DIVISION';
          config.idBuscador = this.action.target.identifier;
          let divisionNoVisible = this.propertyService.instant('NUEVO_TRAMITE_FILTRA_DIVISIONES');
          config.filterDivisionType = divisionNoVisible;
        }

      }
    }
    return config;
  }

  public closeWarningMessage() {
    this.showWarningMessage = false;
  }

  public acceptWarningMessage() {
    this.showWarningMessage = false;
    if (this.warningResult !== undefined) {
      this.close(this.warningResult);
    } else {
      this.close();
    }
  }




  public runMultiTargetAction(params1) {
    params1 += '&async=true';
    this.subscribe(this.plycaService.runAction(this.action.definition.identifier, '', params1).pipe(
      switchMap((result: ActionResultDTO) => {
        let identifier = result.request.identifier;
        return interval(2500).pipe(
          concatMap(() => {
            return this.plycaService.get<ActionExecutionRequestDTO>(this.configuration.ACTION_EXECUTION_REQUEST_SERVICE_URL, identifier)
          }),
          tap((actionExecutionResult: ActionExecutionRequestDTO) => {
            this.patchTargets(actionExecutionResult)
            this.actionExecutionResult = actionExecutionResult;
            try {
              this.selectedActionExecution = this.actionExecutionResult.executions
                .find(r => r.identifier === this.selectedActionExecution.identifier);
            } catch { }
            this.running = true;
            this.waitService.cancelWaiting();
          }),
          filter((value) => value.completionPercentage === 100),
          take(1)
        )
      }),
      tap((actionExecutionResult: ActionExecutionRequestDTO) => {
        // aqui termina
        this.patchTargets(actionExecutionResult)
        this.actionExecutionResult = actionExecutionResult;
        this.totalSeleccionados = actionExecutionResult.executions.length;
        this.totalProcesados = actionExecutionResult.executions.filter(exec => exec.state === ActionExecutionState.SUCCESS).length;
        this.totalErrores = actionExecutionResult.executions.filter(exec => exec.state !== ActionExecutionState.SUCCESS).length;
        this.showFinalResult = true;
      }),
      catchError((error) => {
        this.plycaErrorHandler.showServerError(error);
        return of(error);
      })
    ));
  }

  patchTargets(actionExecutionResult: ActionExecutionRequestDTO) {
    if (actionExecutionResult.executions) {
      actionExecutionResult.executions.forEach(execution => {
        execution.target = actionExecutionResult.targets.find(result => result.identifier === execution.target.identifier);
      });
    }
  }

  showActionExecutionWayPoints(action) {
    this.showingActionExecutionWayPoints = true;
    this.selectedActionExecution = action;
  }

  downloadLogResult() {
    this.subscribe(this.plycaService.downloadLogResult(this.actionExecutionResult.identifier));
  }
}
